import React, { createContext, useContext, useCallback, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const TagsContext = createContext(null);

export function TagsProvider({ children }) {
  const [tags, setTags] = useState([]);

  const reload = useCallback(() => {
    api.get("/tags").then((r) => setTags(r.data || [])).catch(() => setTags([]));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const byKey = useMemo(() => {
    const m = new Map();
    for (const t of tags) m.set(`${t.category}::${t.name}`, t);
    return m;
  }, [tags]);

  const getTag = useCallback((category, name) => {
    if (!name) return null;
    return byKey.get(`${category}::${name}`) || null;
  }, [byKey]);

  // ordered tag list for one or more categories (deduped by name, in sort order)
  const tagsFor = useCallback((categories) => {
    const cats = Array.isArray(categories) ? categories : [categories];
    const list = tags
      .filter((t) => cats.includes(t.category))
      .slice()
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    const seen = new Set();
    const out = [];
    for (const t of list) {
      if (seen.has(t.name)) continue;
      seen.add(t.name);
      out.push(t);
    }
    return out;
  }, [tags]);

  return (
    <TagsContext.Provider value={{ tags, reload, getTag, tagsFor }}>
      {children}
    </TagsContext.Provider>
  );
}

export function useTags() {
  const ctx = useContext(TagsContext);
  if (!ctx) throw new Error("useTags must be used within TagsProvider");
  return ctx;
}
